import { Box, Button, Text, TextInput, DataTable, Select } from "grommet";
import React, { useEffect, useState } from "react";
import "./OnlineFormList.css";
import searchIcon from "../../../../../assets/search.svg";
import view from "../../../../../assets/veiw.svg";
import { useStore } from "../../../../../Hooks/useStore";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import Pagination from "../../common/Pagination/Pagination";
import noResult from "../../../../../assets/no-result.png";
import FormSubmit from "../../../../../services/form/formSubmit";
import UserService from "../IAM/Users/users.service";

const FormList = observer(() => {
  const { rootStore } = useStore();
  const navigate = useNavigate();

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [originalFormList, setOriginalFormList] = useState([]);
  const [sortedFormList, setSortedFormList] = useState([]);
  const [searchString, setSearchString] = useState("");
  const [rootFormDataList, setRootFormDataList] = useState([]);
  const [orgId, setOrgId] = useState(null);

  const onViewClick = (id) => {
    navigate(`/medicalEventReportForm/${id}`);
  };

  useEffect(() => {
    const fetchOrgId = async () => {
      try {
        rootStore.loadingStore.setShowLoader(true);

        // Fetch user details using getDeviceToken
        const userData = await UserService.getDeviceToken("sadmin");
        console.log("tesss");
        console.log(userData);
        if (userData?.organization?.id) {
          setOrgId(userData.organization.id); 
          // alert(`Organization ID: ${userData.organization.id}`);
        } else {
          console.error("Organization ID not found.");
        }
      } catch (error) {
        console.error("Error fetching organization ID:", error);
      } finally {
        rootStore.loadingStore.setShowLoader(false);
      }
    };

    fetchOrgId();
  }, []);

  useEffect(() => {
    if (!orgId) return; // Ensure orgId is set before running this useEffect

    rootStore.loadingStore.setShowLoader(true);
    const userInfo = localStorage.getItem("userinfo");

    if (!userInfo) {
      console.error("User info not found in localStorage");
      rootStore.loadingStore.setShowLoader(false);
      return;
    }

    const user = JSON.parse(userInfo);

    // Call different APIs based on role
    if (user.roleLabel.toLowerCase() === "superadmin") {
      getAllEventReport();
    } else if (user["custom:type"]?.toLowerCase() === "admin") {
      getAllEventReportByOrgId(orgId); // Use orgId from state
    }
  }, [orgId]); // Runs when orgId is set

  const getAllEventReport = async () => {
    try {
      const formData = await FormSubmit.getAllEventReport();
      setRootFormDataList(formData.data);
      setOriginalFormList(formData.data);
      setSortedFormList(formData.data.slice(0, itemsPerPage));
      rootStore.loadingStore.setShowLoader(false);
    } catch (error) {
      console.error("Error fetching forms:", error);
    }
  };

  const getAllEventReportByOrgId = async (orgId) => {
    try {
      const formData = await FormSubmit.getAllEventReportByOrgId(orgId);
      setRootFormDataList(formData.data);
      setOriginalFormList(formData.data);
      setSortedFormList(formData.data.slice(0, itemsPerPage));
      rootStore.loadingStore.setShowLoader(false);
    } catch (error) {
      console.error("Error fetching forms:", error);
    }
  };

  const onSearchStrChange = (value) => {
    setSearchString(value);
    if (value.trim() === "") {
      setRootFormDataList(originalFormList)
    }
  };

  const onSearch = (value) => {
    // Ensure the search term is trimmed and converted to lowercase
    const lowerCaseValue = value.trim().toLowerCase();
  
    // Filter the form list based on the search string matching either medicalEmergencyId or flightNo
    const filteredFormList = originalFormList.filter((item) => {
      let matches = false;
  
      // Convert medicalEmergencyId to string and check if it matches the search value
      if (
        item.medicalEmergencyId &&
        String(item.medicalEmergencyId).toLowerCase().includes(lowerCaseValue)
      ) {
        matches = true;
      }
  
      // Check if the search value matches the flightNo (case insensitive)
      if (
        item.flightNo &&
        typeof item.flightNo === "string" &&
        item.flightNo.toLowerCase().includes(lowerCaseValue)
      ) {
        matches = true;
      }
  
      return matches;
    });
  
    // Update the rootFormDataList with the filtered results
    setRootFormDataList(filteredFormList);
    setCurrentPage(1); // Reset to the first page after search
  };
  
  
  

  const handlePageChange = (page) => {
    setCurrentPage(page);
    setSortedFormList(
      originalFormList.slice(
        (page - 1) * itemsPerPage,
        page * itemsPerPage
      )
    );
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onSearch(searchString); // Trigger search when Enter key is pressed
    }
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const visibleFormDataList = rootFormDataList.slice(
    startIndex,
    endIndex
  );

  return (
    <Box className="formList-container">
      <Box className="form-header">
        <Box className="form-left-header">
          <Box className="form-search-modal">
            <TextInput
              className="form-search-input"
              onChange={(e) => onSearchStrChange(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Search"
            />
            <img src={searchIcon} className="searchIcon" />
          </Box>
          <Button
            className="form-search-btn"
            label="Search"
            onClick={() => onSearch(searchString)}
          />
        </Box>
      </Box>
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box
          className="form-table-container"
          style={{ height: visibleFormDataList.length > 0 ? "calc(100% - 48px)" : "auto"}}
        >
          
          <DataTable
            data={visibleFormDataList}
            resizeable
            className="form-datatable"
            paginate={true}
            step={itemsPerPage}
            columns={[
              {
                align: "center",
                property: "name",
                header: <Text>ID</Text>,
                primary: true,
                render: (item) => <Text>{item.id}</Text>,
              },
              {
                align: "center",
                property: "address",
                header: <Text>Medical Event ID</Text>,
                primary: true,
                render: (item) => <Text>{item.medicalEmergencyId}</Text>,
              },
              {
                align: "center",
                property: "address",
                header: <Text>Tail Number</Text>,
                primary: true,
                render: (item) => <Text>{item.flightNo}</Text>,
              },
              {
                align: "center",
                property: "phone",
                header: <Text>Time</Text>,
                primary: true,
                render: (item) => <Text>{item.createdAt}</Text>,
              },
              {
                align: "center",
                property: "edit",
                header: <Text>Details</Text>,
                primary: true,
                render: (item) => (
                  <Box
                  direction="row"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 12
                    }}
                  >
                  <button className="details-btn" style={{cursor:"pointer"}}
                   onClick={() => onViewClick(item.id)}
                   >
                    <img src={view} style={{height: 11, width: 16}} alt="View" />
                  </button>
                  </Box>
                ),
              },
            ]}
          />
          {visibleFormDataList.length == 0 && (
                  <Box className="no-result-img">
                    <img src={noResult} alt="no emergency found" style={{width:"27%"}} />
                    <p>No form found.</p>
                  </Box>
                )}
        </Box>
        <Box
          className="form-pagination-container"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
            zIndex: 1,
          }}
        >
          { rootFormDataList.length > itemsPerPage && ( 
            <Pagination
              currentPage={currentPage}
              totalPages={Math.ceil(
                rootFormDataList.length / itemsPerPage
              )}
              totalItems = {rootFormDataList.length}
              onPageChange={handlePageChange}
              style={{
                position: "sticky",
                bottom: 0,
                zIndex: 1,
                marginTop: "auto",
              }}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
});

export default FormList;
